import type { TabProps } from '@meterup/atto';

import { paths } from '../../../../constants';
import { useCurrentCompany } from '../../../../providers/CurrentCompanyProvider';
import { useNetworkForSettingsPath } from '../../../../routes/pages/settings/org/networks/NetworkUtils';
import { makeLink } from '../../../../utils/main_and_drawer_navigation';
import { ReactRouterLink } from '../../../ReactRouterLink';

export enum NotificationsTab {
  Alerts = 'alerts',
  Reports = 'reports',
}

export function NotificationsTabs({ activeTab }: { activeTab: NotificationsTab }) {
  const companyName = useCurrentCompany();
  const network = useNetworkForSettingsPath({
    path: paths.pages.SettingsOrgNotificationsPage,
  });

  return [
    {
      as: ReactRouterLink,
      to: makeLink(paths.pages.SettingsOrgNotificationsPage, {
        companyName,
        networkSlug: network.slug,
        tab: NotificationsTab.Alerts,
      }),
      selected: activeTab === NotificationsTab.Alerts,
      icon: 'attention',
      label: 'Alerts',
    },
    {
      as: ReactRouterLink,
      to: makeLink(paths.pages.SettingsOrgNotificationsPage, {
        companyName,
        networkSlug: network.slug,
        tab: NotificationsTab.Reports,
      }),
      selected: activeTab === NotificationsTab.Reports,
      icon: 'email',
      label: 'Reports',
    },
  ] as TabProps[];
}
